/* Goiat · Haz tu combo de tres.
   Tocar una vela la mete en la caja; también se puede arrastrar (ratón: al mover; dedo: manteniendo pulsado).
   «Al azar» rellena los huecos. Con la caja llena, un botón añade las tres al carrito de una vez.
   Los números (unidades, descuento, envío) vienen de la sección, que los lee de snippets/goiat-terms.liquid. */
(function () {
  'use strict';

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var units = +root.dataset.units || 3;
    var pct = +root.dataset.pct || 0;
    var ship = +root.dataset.ship || 0;
    var free = +root.dataset.free || 0;
    var slots = [].slice.call(root.querySelectorAll('[data-gpack-slot]'));
    var candles = [].slice.call(root.querySelectorAll('[data-gpack-candle]'));
    var box = root.querySelector('[data-gpack-box]');
    var status = root.querySelector('[data-gpack-status]');
    var addBtn = root.querySelector('[data-gpack-add]');
    var rndBtn = root.querySelector('[data-gpack-random]');
    var errBox = root.querySelector('[data-gpack-error]');
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var picks = slots.map(function () { return null; });
    var words = String(root.dataset.words || '').split(',');
    /* Textos de la sección (claves goiat.pack.*, en data-i18n): «{n}», «{price}»… se rellenan aquí. */
    var T = {};
    try { T = JSON.parse(root.dataset.i18n || '{}'); } catch (e) {}
    function tr(key, vars) {
      return String(T[key] || '').replace(/\{(\w+)\}/g, function (m, k) { return vars && k in vars ? vars[k] : m; });
    }
    if (!candles.length || !slots.length) return;

    function count() { return picks.filter(Boolean).length; }

    function comboOf(sum) { return Math.round(sum * (100 - pct) / 100); }

    function render() {
      var n = count();
      var sum = 0;
      slots.forEach(function (slot, i) {
        var c = picks[i];
        slot.textContent = '';
        if (c) {
          sum += +c.dataset.price;
          slot.appendChild(c.querySelector('.gthumb').cloneNode(true));
          // Las nueve fotos se parecen: el número de la etiqueta identifica la vela en el hueco.
          var num = (c.dataset.title || '').split(' ').pop();
          if (/^\d+$/.test(num)) {
            var tag = document.createElement('span');
            tag.className = 'gpack__slot-tag';
            tag.setAttribute('aria-hidden', 'true');
            tag.textContent = num;
            slot.appendChild(tag);
          }
          var x = document.createElement('span');
          x.className = 'gpack__slot-x';
          x.setAttribute('aria-hidden', 'true');
          x.textContent = '×';
          slot.appendChild(x);
          slot.disabled = false;
          slot.classList.add('is-full');
          slot.setAttribute('aria-label', tr('slot_remove', { title: c.dataset.title }));
        } else {
          var num = document.createElement('span');
          num.className = 'gpack__slot-n';
          num.textContent = String(i + 1);
          slot.appendChild(num);
          slot.disabled = true;
          slot.classList.remove('is-full');
          slot.setAttribute('aria-label', tr('slot_empty', { n: i + 1 }));
        }
      });
      candles.forEach(function (c) {
        var k = picks.filter(function (p) { return p === c; }).length;
        c.classList.toggle('is-in', k > 0);
        if (k > 0) c.setAttribute('data-count', k); else c.removeAttribute('data-count');
        c.setAttribute('aria-label', k > 0
          ? tr('candle_in', { title: c.dataset.title, n: k })
          : tr('add_label', { title: c.dataset.title }));
      });

      var base = +candles[0].dataset.price * units;
      var target = comboOf(base);
      var included = free > 0 && target >= free;
      if (n === 0) {
        status.innerHTML = tr(included ? 'status_start_free_html' : 'status_start_html', { units: words[units] || units, price: money(target) });
      } else if (n < units) {
        var left = units - n;
        status.innerHTML = tr('status_count', { n: n, units: units }) + ' ' +
          (left === 1 ? tr('status_one_left') : tr('status_left', { left: words[left] || left }));
      } else {
        var total = comboOf(sum);
        status.innerHTML = tr(free > 0 && total >= free ? 'status_full_free_html' : 'status_full_html', { price: money(total), units: words[units] || units });
      }
      addBtn.disabled = n < units;
      addBtn.textContent = n < units
        ? (units - n === 1 ? tr('btn_one_left') : tr('btn_missing', { n: units - n }))
        : tr('btn_add', { price: money(comboOf(sum)) });
      rndBtn.textContent = n === units ? tr('random_again') : tr('random');
      errBox.hidden = true;
    }

    function pop(slot) {
      if (calm) return;
      slot.classList.remove('is-pop');
      void slot.offsetWidth;
      slot.classList.add('is-pop');
    }

    function fly(from, slot) {
      if (calm || !from.animate) return;
      var a = from.querySelector('.gthumb').getBoundingClientRect();
      var b = slot.getBoundingClientRect();
      var ghost = from.querySelector('.gthumb').cloneNode(true);
      ghost.classList.add('gpack__ghost');
      ghost.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px';
      document.body.appendChild(ghost);
      var dx = b.left + b.width / 2 - (a.left + a.width / 2);
      var dy = b.top + b.height / 2 - (a.top + a.height / 2);
      var s = Math.max(b.width / a.width, 0.2);
      ghost.animate(
        [{ transform: 'none', opacity: 1 }, { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ')', opacity: 0.4 }],
        { duration: 380, easing: 'cubic-bezier(.2,.7,.2,1)' }
      ).onfinish = function () { ghost.remove(); };
    }

    function put(candle, animate) {
      var i = picks.indexOf(null);
      if (i < 0) {
        if (!calm) {
          box.classList.remove('is-shake');
          void box.offsetWidth;
          box.classList.add('is-shake');
        }
        return false;
      }
      if (animate) fly(candle, slots[i]);
      picks[i] = candle;
      render();
      pop(slots[i]);
      return true;
    }

    slots.forEach(function (slot, i) {
      slot.addEventListener('click', function () {
        if (!picks[i]) return;
        picks[i] = null;
        render();
        // El hueco vacío queda deshabilitado: el foco pasa al siguiente lleno o a la primera vela.
        var next = slots.filter(function (s) { return !s.disabled; })[0] || candles[0];
        if (next) next.focus();
      });
    });

    rndBtn.addEventListener('click', function () {
      if (count() === units) picks = picks.map(function () { return null; });
      var pool = candles.filter(function (c) { return picks.indexOf(c) < 0; });
      var step = 0;
      picks.forEach(function (p, i) {
        if (p) return;
        var src = pool.length ? pool : candles;
        var c = src.splice(Math.floor(Math.random() * src.length), 1)[0];
        if (calm) { picks[i] = c; return; }
        setTimeout(function () { put(c, true); }, 130 * step++);
      });
      if (calm) render();
    });

    addBtn.addEventListener('click', function () {
      if (count() < units) return;
      var qty = {};
      picks.forEach(function (c) { qty[c.dataset.id] = (qty[c.dataset.id] || 0) + 1; });
      var items = Object.keys(qty).map(function (id) { return { id: +id, quantity: qty[id] }; });
      addBtn.disabled = true;
      addBtn.textContent = tr('adding');
      fetch(root.dataset.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (res.ok) { window.location.href = root.dataset.cartUrl; return; }
          render();
          errBox.textContent = res.body.description || res.body.message || tr('add_retry');
          errBox.hidden = false;
        })
        .catch(function () {
          render();
          errBox.textContent = tr('add_retry');
          errBox.hidden = false;
        });
    });

    /* Tocar = meter en la caja. Arrastrar: con ratón, al mover; con el dedo, tras mantener pulsado. */
    candles.forEach(function (candle) {
      var drag = null;
      var justDragged = false;

      candle.addEventListener('click', function () {
        if (justDragged) { justDragged = false; return; }
        put(candle, true);
      });

      function start(e) {
        var r = candle.querySelector('.gthumb').getBoundingClientRect();
        var ghost = candle.querySelector('.gthumb').cloneNode(true);
        ghost.classList.add('gpack__ghost', 'gpack__ghost--drag');
        ghost.style.width = Math.min(r.width, 110) + 'px';
        ghost.style.height = Math.min(r.width, 110) * 1.25 + 'px';
        document.body.appendChild(ghost);
        drag.ghost = ghost;
        drag.w = ghost.offsetWidth;
        drag.h = ghost.offsetHeight;
        drag.box = box.getBoundingClientRect();
        ghost.style.left = '0px';
        ghost.style.top = '0px';
        drag.active = true;
        candle.classList.add('is-dragging');
        move(e);
      }

      function move(e) {
        if (!drag || !drag.active) return;
        // Solo transform, con las medidas tomadas al empezar: no se recalcula la página en cada movimiento.
        drag.ghost.style.transform = 'translate(' + (e.clientX - drag.w / 2) + 'px,' + (e.clientY - drag.h * 0.6) + 'px) rotate(-4deg)';
        var b = drag.box;
        drag.over = e.clientX >= b.left && e.clientX <= b.right && e.clientY >= b.top && e.clientY <= b.bottom;
        box.classList.toggle('is-over', drag.over);
      }

      function cancel() {
        if (drag) drag.over = false;
        end();
      }

      function end() {
        if (!drag) return;
        clearTimeout(drag.timer);
        if (drag.active) {
          justDragged = true;
          setTimeout(function () { justDragged = false; }, 60);
          drag.ghost.remove();
          candle.classList.remove('is-dragging');
          box.classList.remove('is-over');
          if (drag.over) put(candle, false);
        }
        drag = null;
      }

      candle.addEventListener('pointerdown', function (e) {
        if (e.button) return;
        drag = { x: e.clientX, y: e.clientY, active: false, over: false, touch: e.pointerType !== 'mouse' };
        if (drag.touch) {
          var ev = { clientX: e.clientX, clientY: e.clientY };
          drag.timer = setTimeout(function () { if (drag) start(ev); }, 240);
        }
      });
      candle.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var far = Math.abs(e.clientX - drag.x) + Math.abs(e.clientY - drag.y) > 8;
        if (!drag.active) {
          if (drag.touch) { if (far) { clearTimeout(drag.timer); drag = null; } return; }
          if (far) { try { candle.setPointerCapture(e.pointerId); } catch (x) {} start(e); }
          return;
        }
        move(e);
      });
      candle.addEventListener('touchmove', function (e) { if (drag && drag.active) e.preventDefault(); }, { passive: false });
      candle.addEventListener('contextmenu', function (e) { if (drag) e.preventDefault(); });
      candle.addEventListener('pointerup', end);
      candle.addEventListener('pointercancel', cancel);
      candle.addEventListener('lostpointercapture', function () { if (drag && drag.active && !drag.touch) end(); });
      window.addEventListener('blur', cancel);
      document.addEventListener('visibilitychange', function () { if (document.hidden) cancel(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cancel(); });
      candle.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    render();
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-gpack]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
